import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import DialogList from 'src/dialogs';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import TimeSheet from '../models/Summary';

interface IGenerateTimesheetDialogProps {
    dialogName: string;
    handleSubmit?: (payload: TimeSheet, backup: boolean) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;    
    setGeneratingDocument?: (generating: boolean) => void;
}

const GenerateTimesheetDialog = (props: IGenerateTimesheetDialogProps) => {
    const { register, errors, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    const OKClicked = () => {
        let data = getValues();
        const payload: Partial<TimeSheet> = {
            ...data.generateTimesheet
        };
/*         if (props?.setGeneratingDocument) {
            props.setGeneratingDocument(true);
        } */
        props.handleSubmit(payload, payload.backup);
        props.hideDialog();

        console.log(data);
    };

    return (
        <Dialog title="Generate Timesheet" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                        <RHFCheckbox
                            name={`generateTimesheet.timesheet`}
                            label={`Timesheet`}
                            register={register}
                            bodyStyle={{whiteSpace: 'nowrap', width: '25%', display: 'flex', alignItems: 'center', gap: '0.5rem;'}}
                        />
                        <RHFCheckbox
                            name={`generateTimesheet.recap`}
                            label={`Recap`}
                            register={register}
                            bodyStyle={{whiteSpace: 'nowrap', width: '25%', display: 'flex', alignItems: 'center', gap: '0.5rem;'}}
                        />
                        <RHFCheckbox
                            name={`generateTimesheet.expense`}
                            label={`Expenses`}
                            register={register}
                            bodyStyle={{whiteSpace: 'nowrap', width: '25%', display: 'flex', alignItems: 'center', gap: '0.5rem'}}
                        />
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                        <RHFCheckbox
                            name={`generateTimesheet.omitServices`}
                            label={`Omit Services`}
                            register={register}
                            bodyStyle={{whiteSpace: 'nowrap', width: '25%', display: 'flex', alignItems: 'center', gap: '0.5rem;'}}
                        />
                        <RHFCheckbox
                            name={`generateTimesheet.backup`}
                            label={`Backup`}
                            register={register}
                            bodyStyle={{whiteSpace: 'nowrap', width: '25%', display: 'flex', alignItems: 'center', gap: '0.5rem;'}}
                        />
                        <RHFCheckbox
                            name={`generateTimesheet.invoiceDetail`}
                            label={`Invoice Detail`}
                            register={register}
                            bodyStyle={{whiteSpace: 'nowrap', width: '25%', display: 'flex', alignItems: 'center', gap: '0.5rem;'}}
                        />
                    </div>
                    <RHFInputBox
                        labelStyle={{marginRight: '4.5rem', whiteSpace: 'nowrap'}}
                        label="Start Date"
                        labelOnLeft={true}
                        name={`generateTimesheet.beginDate`}
                        type="date"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '62%' }}
                    />
                    <RHFInputBox
                        label="End Date"
                        labelOnLeft={true}
                        labelStyle={{marginRight: '4.5rem', whiteSpace: 'nowrap'}}
                        name={`generateTimesheet.endDate`}
                        type="date"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '60%' }}
                    />
                    <RHFInputBox
                        label="Employee Number"
                        labelOnLeft={true}
                        labelStyle={{marginRight: '1.25rem', whiteSpace: 'nowrap'}}
                        name={`generateTimesheet.employeeNumber`}
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '85%' }}
                    />
                    <RHFInputBox
                        label="Client Number"
                        labelOnLeft={true}
                        labelStyle={{marginRight: '1.25rem', whiteSpace: 'nowrap'}}
                        name={`generateTimesheet.clientNumber`}
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '85%' }}
                    />
                    <RHFInputBox
                        label="Project Number"
                        labelOnLeft={true}
                        labelStyle={{marginRight: '1rem', whiteSpace: 'nowrap'}}
                        name={`generateTimesheet.projectNumber`}
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '85%' }}
                    />
                    <RHFInputBox
                        label="Subcode"
                        labelOnLeft={true}
                        labelStyle={{marginRight: '5.65rem', whiteSpace: 'nowrap'}}
                        name={`generateTimesheet.subcode`}
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '85%' }}
                    />
                    <RHFInputBox
                        label="Alt Subcode"
                        labelOnLeft={true}
                        labelStyle={{ width: '15rem'}}
                        name={`generateTimesheet.altSubcode`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ whiteSpace: 'nowrap', width: '26%', marginRight: '1rem' }}
                    text={'Generate Timesheet'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default GenerateTimesheetDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/GenerateTimesheetDialog.tsx